export enum ClientTypes {
  LEGAL_RESIDENT = 'LEGAL_RESIDENT', // id: "3"
  ASSET_MANAGER = 'ASSET_MANAGER', // id: "0"
  LEGAL_NON_RESIDENT_F = 'LEGAL_NON_RESIDENT_F', // id: "A"
  LEGAL_NON_RESIDENT = 'LEGAL_NON_RESIDENT', // id: "C"
  SOLE_TRADER = 'SOLE_TRADER', // id: "E"
  NON_PROFIT = 'NON_PROFIT', // id: "G"
}

export const CLIENT_TYPES_ID = {
  [ClientTypes.LEGAL_RESIDENT]: '3',
  [ClientTypes.ASSET_MANAGER]: '0',
  [ClientTypes.LEGAL_NON_RESIDENT_F]: 'A',
  [ClientTypes.LEGAL_NON_RESIDENT]: 'C',
  [ClientTypes.SOLE_TRADER]: 'E',
  [ClientTypes.NON_PROFIT]: 'G',
};

export enum ManagerRole {
  manager = 'manager',
  observer = 'observer',
  call_center_operator = 'call_center_operator',
  covenants_branch_manager = 'covenants_branch_manager',
  branch_manager = 'branch_manager',
  personal_data_manager = 'personal_data_manager',
  uakdo_administrator = 'uakdo_administrator',
  supervisor = 'supervisor',
}

export enum ClientRole {
  CLIENT = 'CLIENT',
  ASSET_MANAGER = 'ROLE_ASSET_MANAGER',
  ADMIN = 'ADMIN',
  ROLE_REMOTE_BANKING_CONTACTS = 'ROLE_REMOTE_BANKING_CONTACTS',
  ROLE_REMOTE_BANKING_DIRECTOR = 'ROLE_REMOTE_BANKING_DIRECTOR',
  REMOTE_BANKING_ACCOUNT_MANAGER = 'REMOTE_BANKING_ACCOUNT_MANAGER',
}
